import $ from 'jquery';
import { updateTextOnly } from '@/js/modules/update_text_only';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getFlatRateServiceIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    ids = ids.filter((id) => id);

    return new Set(ids);
  }

  function setFlatRateServiceIds(ids) {
    const params = queryString();

    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function pointAtSelection(button, ids) {
    const attribute = 'data-ui--twin-turbo-modal-trigger-url-value';
    const url = new URL(button.getAttribute(attribute), window.location.origin);
    url.searchParams.delete('ids[]');
    ids.forEach((id) => url.searchParams.append('ids[]', id));
    button.setAttribute(attribute, url.pathname + url.search);
  }

  function updateFlatRateServicesControls() {
    const selectedCheckboxesLength = $('.checkbox--flat-rate-services:checked').length;
    const flatRateServicesCount = $('.data-table__tr').length;
    const selectedIds = getFlatRateServiceIds();
    const totalSelectedFlatRateServices = selectedIds.size;

    $('.h-d-button--delete-flat-rate-services').each((_, button) =>
      pointAtSelection(button, selectedIds)
    );

    if (totalSelectedFlatRateServices > 0) {
      updateTextOnly(
        $('.h-d-button--delete-flat-rate-services'),
        `Delete (${totalSelectedFlatRateServices})`
      ).removeClass('hide');

      $('.flat-rate-services-search-form').hide();
    } else {
      $('.h-d-button--delete-flat-rate-services').addClass('hide');
      $('.flat-rate-services-search-form').show();
    }

    // check/uncheck the "check all" checkbox based on count
    $('.checkbox--flat-rate-services-check-all').prop(
      'checked',
      selectedCheckboxesLength === flatRateServicesCount
    );
  }

  $(document).ready(() => {
    getFlatRateServiceIds().forEach((flatRateServiceId) => {
      $(`.data-table__tr[data-id=${flatRateServiceId}]`)
        .find('.checkbox--flat-rate-services')
        .prop('checked', true);
    });
    updateFlatRateServicesControls();
  });

  $(document).on('change', '.checkbox--flat-rate-services', (e) => {
    const ids = getFlatRateServiceIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));

    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if ($(e.target).is(':checked')) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setFlatRateServiceIds(ids);
    updateFlatRateServicesControls();
  });

  $(document).on('change', '.checkbox--flat-rate-services-check-all', (e) => {
    $('.checkbox--flat-rate-services').prop('checked', $(e.target).prop('checked')).change();

    updateFlatRateServicesControls();
  });

  $(document).on('click', '.flat-rate-services-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.flat-rate-services-search-form__field').val('');
    $el.parents('.flat-rate-services-search-form').submit();
  });
});
